export function isChosenColor(color: string, defaultColor: string): boolean {
  return Boolean(color) && color.toLowerCase() !== defaultColor.toLowerCase();
}
